import { useContext } from 'react';

import { VehicleLookupContext } from 'Context/vehicleLookup';

import { INCODE_VERIFICATION_SELLER_TYPE, useIncodeVerificationDocuments } from './uploadDocuments/pages/IncodeSDKPage/hooks/useIncodeVerificationDocuments';
import { checkDocumentActionStatus, Document, DOCUMENT_CAPTURE_RESPONSE_API_KEYS } from './DocumentCapture.helpers';
import { DocumentCaptureConfirmationProgressContextType } from './DocumentCaptureContexts';

export const useDocumentCaptureRoutesState = (
  documentCaptureConfirmationProgressContext: DocumentCaptureConfirmationProgressContextType['progress'],
) => {
  const { vehicleLookupState: vehicle } = useContext(VehicleLookupContext);
  const { hasActiveIncodeSession, isLoading: isVerificationDocumentsLoading } = useIncodeVerificationDocuments({
    enquiryId: vehicle?.enquiry?.dpEnquiryId,
    verificationType: INCODE_VERIFICATION_SELLER_TYPE,
  });

  const {
    [DOCUMENT_CAPTURE_RESPONSE_API_KEYS.BANK_DETAILS_ADDED]: bankDetailsAdded,
    [DOCUMENT_CAPTURE_RESPONSE_API_KEYS.CONFIRMED_SALE]: confirmedBySeller,
    [DOCUMENT_CAPTURE_RESPONSE_API_KEYS.DOCUMENTS_FULFILLED]: documentsFulfilled,
    [DOCUMENT_CAPTURE_RESPONSE_API_KEYS.BANK_DETAILS_REVIEW_FAILED]: bankDetailsFailed,
    [DOCUMENT_CAPTURE_RESPONSE_API_KEYS.DOCUMENTS]: documents,
  } = documentCaptureConfirmationProgressContext;

  const hasBankDetailsAdded = bankDetailsAdded && !bankDetailsFailed;
  const saleConfirmed = confirmedBySeller;

  // DocumentsAdded is true when all images have been uploaded. However if there some are rejected by agents in
  // dashboard they will be sent back with an action in the response.
  // If some images have actions, documents will not be fulfilled allowing reentry
  const documentsAdded = documentsFulfilled;

  const documentsAddedViaIncode = !isVerificationDocumentsLoading && hasActiveIncodeSession;

  const hasDocumentsFulfilled = documentsAdded && !checkDocumentActionStatus(documents as Document[]);

  return {
    [DOCUMENT_CAPTURE_RESPONSE_API_KEYS.BANK_DETAILS_ADDED]: hasBankDetailsAdded,
    [DOCUMENT_CAPTURE_RESPONSE_API_KEYS.CONFIRMED_SALE]: saleConfirmed,
    [DOCUMENT_CAPTURE_RESPONSE_API_KEYS.DOCUMENTS_FULFILLED]: !documentsAddedViaIncode && hasDocumentsFulfilled,
    [DOCUMENT_CAPTURE_RESPONSE_API_KEYS.BANK_DETAILS_REVIEW_FAILED]: bankDetailsFailed,
    [DOCUMENT_CAPTURE_RESPONSE_API_KEYS.DOCUMENTS]: documents,
  };
};
